/**
 * Watch screen for movies feature (from Netflix clone). Uses only features/movies MoviesPlayer.
 */

import {Trans} from '@lingui/macro'
import type {NativeStackScreenProps} from '@react-navigation/native-stack'
import {View} from 'react-native'
import type {CommonNavigatorParams} from '#/lib/routes/types'
import * as Layout from '#/components/Layout'
import {Text} from '#/components/Typography'
import {MoviesPlayer} from '#/features/movies/MoviesPlayer'
import {atoms as a, useTheme} from '#/alf'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'MoviesWatch'>

export function MoviesWatchScreen({route}: Props) {
  const params = route.params
  const t = useTheme()

  if (!params?.tmdbId || !params?.contentType) {
    return (
      <Layout.Screen testID="moviesWatchScreen">
        <Layout.Header.Outer>
          <Layout.Header.BackButton />
          <Layout.Header.Content>
            <Layout.Header.TitleText>
              <Trans>Watch</Trans>
            </Layout.Header.TitleText>
          </Layout.Header.Content>
          <Layout.Header.Slot />
        </Layout.Header.Outer>
        <View style={[a.flex_1, a.justify_center, a.p_lg]}>
          <Text style={[a.text_center, t.atoms.text_contrast_high]}>
            <Trans>Invalid video. Go back to browse.</Trans>
          </Text>
        </View>
      </Layout.Screen>
    )
  }

  const {tmdbId, contentType, title, initialSeason, initialEpisode} = params

  return (
    <Layout.Screen testID="moviesWatchScreen">
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          <Layout.Header.TitleText>
            {title || (contentType === 'tv' ? 'TV Show' : 'Movie')}
          </Layout.Header.TitleText>
        </Layout.Header.Content>
        <Layout.Header.Slot />
      </Layout.Header.Outer>
      <MoviesPlayer
        tmdbId={tmdbId}
        contentType={contentType}
        title={title}
        initialSeason={initialSeason}
        initialEpisode={initialEpisode}
      />
    </Layout.Screen>
  )
}
